// sheetIndices( Number, Number )

// So, everything in threejs is a triangle
// And triangles are just three (counter-clockwise) points
// Meshes can re-use points; points are referred to by index
// I want to work with Mesh "sheets" (my word for deformed rectangles)
// In order to define those meshes from a list of points in a rectangular grid,
// I use this function, which tells the mesh how to connect the dots
// and build all of the triangles it needs to make a mesh

// takes two numbers (width and height)
// returns a list of integers (indexes in an array with width * height items)


// Some functions for navigating the grid...

// These return booleans. Are we in the last row or column?
const lastCol = ( index, width ) =>
	index % width === width - 1;
const lastRow = ( index, width, height ) => 
	Math.floor( index / width ) === height - 1;

// These let us "move around" the mesh by returning the index of the point
// either to the right, or below, the current point.
// (We are starting at the top left and always moving either right or down.)
const right = ( index, width ) => {
	if ( lastCol( index, width ) ) { // nowhere to go
		return null;
	}
	return index + 1;
}
const down = ( index, width, height ) => {
	if ( lastRow( index, width, height ) ) { // nowhere to go
		return null;
	}
	return index + width;
}

// Now we can start drawing triangles

/*
from index zero returns 0,3,1
 0---1   2
 | /
 3   4   5  
*/
const topTriangle = ( index, width, height ) => [
	index,
	down( index, width, height ),
	right( index, width )
];
// need to reverse handedness? going 0,1,3
// should handedness be an option or should I be more consistent somehow?
// const topTriangle = ( index, width, height ) => [
// 	index,
// 	right( index, width ),
// 	down( index, width, height )
// ];


/* from index zero returns 1,3,4
 0   1   2
   / |
 3---4   5
 */
const bottomTriangle = ( index, width, height ) => [
	right( index, width ),
	down( index, width, height ),
	down( right( index, width ), width, height )
];
// // need to reverse handedness? going 1,4,3
//  const bottomTriangle = ( index, width, height ) => [
// 	right( index, width ),
// 	down( right( index, width ), width, height ),
// 	down( index, width, height )
// ];
 
// Now we can draw squares!
 
 /* from index zero returns 0,3,1,1,3,4
 0---1   2
 | / |
 3---4   5
 */
const rect = ( index, width, height ) => 
	topTriangle( index, width, height )
		.concat( bottomTriangle( index, width, height ) );

// Now we can draw as many squares as we need to connect all the dots
// in a grid with a given width and height

const sheetIndices = ( width, height ) => {
	if ( height === undefined ) { // allow squares with one param
		height = width;
	}
	const vertexIndices = new Array( width * height )
		.fill( 0 )
		.map( ( _, i ) => i );
	return vertexIndices.map( ( index ) => {
		if (
			lastCol( index, width ) ||
			lastRow( index, width, height )
		) {
			return null;
		}
		return rect( index, width, height );
	} )
		.filter( x => x ) // filter nulls
		.flat();
}

export default sheetIndices;
